/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./NavBar.css";
import { useKeycloak } from "@react-keycloak/web";

const NavBar = () => {
  
  const [burgerMenuActive, setBurgerMenuActive] = useState(false);
  const { keycloak, initialized } = useKeycloak();
  return (
    <nav className="navbar is-white">
      <div className="navbar-brand">
        <a
          role="button"
          className="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarMobile"
          onClick={() => setBurgerMenuActive(!burgerMenuActive)}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        id="navbarMobile"
        className={burgerMenuActive ? "navbar-menu is-active" : "navbar-menu"}
      >
        <div className="navbar-start">
          <div className="navbar-item has-dropdown is-hoverable">
            <a className="navbar-link">
              <strong>
                <i className="fas fa-bars"></i>
              </strong>
            </a>
            <div className="navbar-dropdown">
              <Link to="/" className="navbar-item">
                <i className="fas fa-home"></i>
                Home
              </Link>

              <Link to="/userattributes" className="navbar-item">
                <i className="fas fa-user"></i>
                UserAttributes
              </Link>
            
              <Link to="/panden" className="navbar-item">
                <i className="fas fa-warehouse"></i>
                Pandenoverzicht
              </Link>
              <Link to="/onderhoudstaken" className="navbar-item">
                <i className="fas fa-tools"></i>
                Onderhoudstaken
              </Link>
              <hr className="navbar-divider" />

              <a
                href="https://iamposdev.ig-nl.com/api/admin/"
                className="navbar-item"
              >
                <i className="fas fa-user-friends"></i>
                Gebruikersadministratie
              </a>
            </div>
          </div>
        </div>
        <div className="navbar-end">
          <div className="navbar-item">
            
          {!keycloak.authenticated && (
            <div className="buttons" onClick={() => keycloak.login() }>
              <div className="button is-black is-outlined is-small log-in-button" >
                <i className="fas fa-user-lock"></i>
                <strong> Login </strong>
                {/* <strong> Login {!!keycloak.authenticated && <b>({keycloak.tokenParsed.preferred_username})</b> } </strong> */}
              </div>
            </div>
          )}

          {!!keycloak.authenticated && (
            <div className="buttons" onClick={() => keycloak.logout()}>
            <div className="button is-black is-outlined is-small log-out-button">
              <i className="fas fa-user-lock"></i>
              <strong>Logout ({keycloak.tokenParsed.preferred_username})</strong>
              </div>
              </div>
          )}



          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
